import { render } from "./GarantiesView.vue?vue&type=template&id=0bd1244e"
import script from "./GarantiesView.vue?vue&type=script&lang=js"
export * from "./GarantiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__